// 服务器配置
// 生产环境使用API子域名，开发环境使用localhost
export const API_BASE_URL = process.env.REACT_APP_API_URL || 
  (process.env.NODE_ENV === 'production' ? 'https://api.toxchat.online' : 'http://localhost:8080');

export const WS_URL = process.env.REACT_APP_WS_URL || 
  (process.env.NODE_ENV === 'production' ? 'wss://api.toxchat.online/ws' : 'ws://localhost:8080/ws');

// 服务器公钥 - 用于加密发送给服务器的数据
export const SERVER_PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAu0B8++a3jter0+8fXhHr
pvbPT9OjGpgXmaNkMXswa3Q+Peu770ZiyRJdL74+Jf5GizRWgB8FMYvCce5i1QPM
gF7GxE61WDNdDaZCuRzKifaO8jNefHd4FjI+4GU/fd4Mu3SI/WpjRpzUbLfpA+8I
uT1DCFLcvJ/Fsml0WrAuCtiILd8YR1bWEpdDi7Z7iH5MN09qOrCBRoG71gwA65YI
IC+jyt0JRG24S+qlowMlCVgzV/cOzG1fzr4roKZYOBEEx3fwbcI+hKB9eSOgz4Tz
YUI3pXjYGzETnz8FYIKodFqbAFehoV9rO/wgZS8YZ0pxZiMhNfJNjjBxaWYuBqNZ
bQIDAQAB
-----END PUBLIC KEY-----`;

// 应用配置
export const APP_CONFIG = {
  appName: 'ToxChat',
  version: '1.2.3',
  maxMessageLength: 1000,
  messageHistoryLimit: 100,
  reconnectInterval: 3000,
  heartbeatInterval: 30000
};

// 环境配置
export const ENV_CONFIG = {
  isDevelopment: process.env.NODE_ENV === 'development',
  isProduction: process.env.NODE_ENV === 'production',
  apiUrl: API_BASE_URL,
  wsUrl: WS_URL
};

// 调试信息（仅在开发环境显示）
if (process.env.NODE_ENV === 'development') {
  console.log('🔧 开发环境配置:');
  console.log('API URL:', API_BASE_URL);
  console.log('WebSocket URL:', WS_URL);
}